/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GetStartedRouteImport } from './routes/get-started'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as OrgPidRouteImport } from './routes/$orgPid'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as OwnerStatusTokenRouteImport } from './routes/owner-status.$token'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminJobsRouteImport } from './routes/admin/jobs'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminCompaniesRouteImport } from './routes/admin/companies'
import { Route as AdminChartersRouteImport } from './routes/admin/charters'
import { Route as OrgPidSubscriptionsRouteImport } from './routes/$orgPid/subscriptions'
import { Route as OrgPidRolesRouteImport } from './routes/$orgPid/roles'
import { Route as OrgPidRevenueRouteImport } from './routes/$orgPid/revenue'
import { Route as OrgPidPricingCalendarRouteImport } from './routes/$orgPid/pricing-calendar'
import { Route as OrgPidPriceAlertsRouteImport } from './routes/$orgPid/price-alerts'
import { Route as OrgPidOwnersRouteImport } from './routes/$orgPid/owners'
import { Route as OrgPidMessagingRouteImport } from './routes/$orgPid/messaging'
import { Route as OrgPidMembersRouteImport } from './routes/$orgPid/members'
import { Route as OrgPidMarketExplorerRouteImport } from './routes/$orgPid/market-explorer'
import { Route as OrgPidIntegrationsRouteImport } from './routes/$orgPid/integrations'
import { Route as OrgPidDynamicPricingRouteImport } from './routes/$orgPid/dynamic-pricing'
import { Route as OrgPidDashboardRouteImport } from './routes/$orgPid/dashboard'
import { Route as OrgPidAnalyticsRouteImport } from './routes/$orgPid/analytics'
import { Route as OrgPidActivityRouteImport } from './routes/$orgPid/activity'
import { Route as OrgPidCompetitorSetsIndexRouteImport } from './routes/$orgPid/competitor-sets.index'
import { Route as OrgPidAnalyticsIndexRouteImport } from './routes/$orgPid/analytics.index'
import { Route as OrgPidCompetitorSetsPidRouteImport } from './routes/$orgPid/competitor-sets.$pid'
import { Route as OrgPidAnalyticsRevenueRouteImport } from './routes/$orgPid/analytics.revenue'
import { Route as OrgPidAnalyticsOccupancyRouteImport } from './routes/$orgPid/analytics.occupancy'
import { Route as OrgPidAnalyticsIncomeRouteImport } from './routes/$orgPid/analytics.income'
import { Route as OrgPidAnalyticsGoalsRouteImport } from './routes/$orgPid/analytics.goals'
import { Route as OrgPidAnalyticsCompetitorsRouteImport } from './routes/$orgPid/analytics.competitors'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GetStartedRoute = GetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgPidRoute = OrgPidRouteImport.update({
  id: '/$orgPid',
  path: '/$orgPid',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const OwnerStatusTokenRoute = OwnerStatusTokenRouteImport.update({
  id: '/owner-status/$token',
  path: '/owner-status/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsRoute = AdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompaniesRoute = AdminCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChartersRoute = AdminChartersRouteImport.update({
  id: '/charters',
  path: '/charters',
  getParentRoute: () => AdminRoute,
} as any)
const OrgPidSubscriptionsRoute = OrgPidSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidRolesRoute = OrgPidRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidRevenueRoute = OrgPidRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidPricingCalendarRoute = OrgPidPricingCalendarRouteImport.update({
  id: '/pricing-calendar',
  path: '/pricing-calendar',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidPriceAlertsRoute = OrgPidPriceAlertsRouteImport.update({
  id: '/price-alerts',
  path: '/price-alerts',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidOwnersRoute = OrgPidOwnersRouteImport.update({
  id: '/owners',
  path: '/owners',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidMessagingRoute = OrgPidMessagingRouteImport.update({
  id: '/messaging',
  path: '/messaging',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidMembersRoute = OrgPidMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidMarketExplorerRoute = OrgPidMarketExplorerRouteImport.update({
  id: '/market-explorer',
  path: '/market-explorer',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidIntegrationsRoute = OrgPidIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidDynamicPricingRoute = OrgPidDynamicPricingRouteImport.update({
  id: '/dynamic-pricing',
  path: '/dynamic-pricing',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidDashboardRoute = OrgPidDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidAnalyticsRoute = OrgPidAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidActivityRoute = OrgPidActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidCompetitorSetsIndexRoute =
  OrgPidCompetitorSetsIndexRouteImport.update({
    id: '/competitor-sets/',
    path: '/competitor-sets/',
    getParentRoute: () => OrgPidRoute,
  } as any)
const OrgPidAnalyticsIndexRoute = OrgPidAnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgPidAnalyticsRoute,
} as any)
const OrgPidCompetitorSetsPidRoute = OrgPidCompetitorSetsPidRouteImport.update({
  id: '/competitor-sets/$pid',
  path: '/competitor-sets/$pid',
  getParentRoute: () => OrgPidRoute,
} as any)
const OrgPidAnalyticsRevenueRoute = OrgPidAnalyticsRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => OrgPidAnalyticsRoute,
} as any)
const OrgPidAnalyticsOccupancyRoute =
  OrgPidAnalyticsOccupancyRouteImport.update({
    id: '/occupancy',
    path: '/occupancy',
    getParentRoute: () => OrgPidAnalyticsRoute,
  } as any)
const OrgPidAnalyticsIncomeRoute = OrgPidAnalyticsIncomeRouteImport.update({
  id: '/income',
  path: '/income',
  getParentRoute: () => OrgPidAnalyticsRoute,
} as any)
const OrgPidAnalyticsGoalsRoute = OrgPidAnalyticsGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => OrgPidAnalyticsRoute,
} as any)
const OrgPidAnalyticsCompetitorsRoute =
  OrgPidAnalyticsCompetitorsRouteImport.update({
    id: '/competitors',
    path: '/competitors',
    getParentRoute: () => OrgPidAnalyticsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$orgPid': typeof OrgPidRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/get-started': typeof GetStartedRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/$orgPid/activity': typeof OrgPidActivityRoute
  '/$orgPid/analytics': typeof OrgPidAnalyticsRouteWithChildren
  '/$orgPid/dashboard': typeof OrgPidDashboardRoute
  '/$orgPid/dynamic-pricing': typeof OrgPidDynamicPricingRoute
  '/$orgPid/integrations': typeof OrgPidIntegrationsRoute
  '/$orgPid/market-explorer': typeof OrgPidMarketExplorerRoute
  '/$orgPid/members': typeof OrgPidMembersRoute
  '/$orgPid/messaging': typeof OrgPidMessagingRoute
  '/$orgPid/owners': typeof OrgPidOwnersRoute
  '/$orgPid/price-alerts': typeof OrgPidPriceAlertsRoute
  '/$orgPid/pricing-calendar': typeof OrgPidPricingCalendarRoute
  '/$orgPid/revenue': typeof OrgPidRevenueRoute
  '/$orgPid/roles': typeof OrgPidRolesRoute
  '/$orgPid/subscriptions': typeof OrgPidSubscriptionsRoute
  '/admin/charters': typeof AdminChartersRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/owner-status/$token': typeof OwnerStatusTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/$orgPid/analytics/competitors': typeof OrgPidAnalyticsCompetitorsRoute
  '/$orgPid/analytics/goals': typeof OrgPidAnalyticsGoalsRoute
  '/$orgPid/analytics/income': typeof OrgPidAnalyticsIncomeRoute
  '/$orgPid/analytics/occupancy': typeof OrgPidAnalyticsOccupancyRoute
  '/$orgPid/analytics/revenue': typeof OrgPidAnalyticsRevenueRoute
  '/$orgPid/competitor-sets/$pid': typeof OrgPidCompetitorSetsPidRoute
  '/$orgPid/analytics/': typeof OrgPidAnalyticsIndexRoute
  '/$orgPid/competitor-sets/': typeof OrgPidCompetitorSetsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$orgPid': typeof OrgPidRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/get-started': typeof GetStartedRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/$orgPid/activity': typeof OrgPidActivityRoute
  '/$orgPid/dashboard': typeof OrgPidDashboardRoute
  '/$orgPid/dynamic-pricing': typeof OrgPidDynamicPricingRoute
  '/$orgPid/integrations': typeof OrgPidIntegrationsRoute
  '/$orgPid/market-explorer': typeof OrgPidMarketExplorerRoute
  '/$orgPid/members': typeof OrgPidMembersRoute
  '/$orgPid/messaging': typeof OrgPidMessagingRoute
  '/$orgPid/owners': typeof OrgPidOwnersRoute
  '/$orgPid/price-alerts': typeof OrgPidPriceAlertsRoute
  '/$orgPid/pricing-calendar': typeof OrgPidPricingCalendarRoute
  '/$orgPid/revenue': typeof OrgPidRevenueRoute
  '/$orgPid/roles': typeof OrgPidRolesRoute
  '/$orgPid/subscriptions': typeof OrgPidSubscriptionsRoute
  '/admin/charters': typeof AdminChartersRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/owner-status/$token': typeof OwnerStatusTokenRoute
  '/admin': typeof AdminIndexRoute
  '/$orgPid/analytics/competitors': typeof OrgPidAnalyticsCompetitorsRoute
  '/$orgPid/analytics/goals': typeof OrgPidAnalyticsGoalsRoute
  '/$orgPid/analytics/income': typeof OrgPidAnalyticsIncomeRoute
  '/$orgPid/analytics/occupancy': typeof OrgPidAnalyticsOccupancyRoute
  '/$orgPid/analytics/revenue': typeof OrgPidAnalyticsRevenueRoute
  '/$orgPid/competitor-sets/$pid': typeof OrgPidCompetitorSetsPidRoute
  '/$orgPid/analytics': typeof OrgPidAnalyticsIndexRoute
  '/$orgPid/competitor-sets': typeof OrgPidCompetitorSetsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/$orgPid': typeof OrgPidRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/get-started': typeof GetStartedRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/$orgPid/activity': typeof OrgPidActivityRoute
  '/$orgPid/analytics': typeof OrgPidAnalyticsRouteWithChildren
  '/$orgPid/dashboard': typeof OrgPidDashboardRoute
  '/$orgPid/dynamic-pricing': typeof OrgPidDynamicPricingRoute
  '/$orgPid/integrations': typeof OrgPidIntegrationsRoute
  '/$orgPid/market-explorer': typeof OrgPidMarketExplorerRoute
  '/$orgPid/members': typeof OrgPidMembersRoute
  '/$orgPid/messaging': typeof OrgPidMessagingRoute
  '/$orgPid/owners': typeof OrgPidOwnersRoute
  '/$orgPid/price-alerts': typeof OrgPidPriceAlertsRoute
  '/$orgPid/pricing-calendar': typeof OrgPidPricingCalendarRoute
  '/$orgPid/revenue': typeof OrgPidRevenueRoute
  '/$orgPid/roles': typeof OrgPidRolesRoute
  '/$orgPid/subscriptions': typeof OrgPidSubscriptionsRoute
  '/admin/charters': typeof AdminChartersRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/owner-status/$token': typeof OwnerStatusTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/$orgPid/analytics/competitors': typeof OrgPidAnalyticsCompetitorsRoute
  '/$orgPid/analytics/goals': typeof OrgPidAnalyticsGoalsRoute
  '/$orgPid/analytics/income': typeof OrgPidAnalyticsIncomeRoute
  '/$orgPid/analytics/occupancy': typeof OrgPidAnalyticsOccupancyRoute
  '/$orgPid/analytics/revenue': typeof OrgPidAnalyticsRevenueRoute
  '/$orgPid/competitor-sets/$pid': typeof OrgPidCompetitorSetsPidRoute
  '/$orgPid/analytics/': typeof OrgPidAnalyticsIndexRoute
  '/$orgPid/competitor-sets/': typeof OrgPidCompetitorSetsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/$orgPid'
    | '/admin'
    | '/forgot-password'
    | '/get-started'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/$orgPid/activity'
    | '/$orgPid/analytics'
    | '/$orgPid/dashboard'
    | '/$orgPid/dynamic-pricing'
    | '/$orgPid/integrations'
    | '/$orgPid/market-explorer'
    | '/$orgPid/members'
    | '/$orgPid/messaging'
    | '/$orgPid/owners'
    | '/$orgPid/price-alerts'
    | '/$orgPid/pricing-calendar'
    | '/$orgPid/revenue'
    | '/$orgPid/roles'
    | '/$orgPid/subscriptions'
    | '/admin/charters'
    | '/admin/companies'
    | '/admin/dashboard'
    | '/admin/jobs'
    | '/admin/users'
    | '/owner-status/$token'
    | '/admin/'
    | '/$orgPid/analytics/competitors'
    | '/$orgPid/analytics/goals'
    | '/$orgPid/analytics/income'
    | '/$orgPid/analytics/occupancy'
    | '/$orgPid/analytics/revenue'
    | '/$orgPid/competitor-sets/$pid'
    | '/$orgPid/analytics/'
    | '/$orgPid/competitor-sets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/$orgPid'
    | '/forgot-password'
    | '/get-started'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/$orgPid/activity'
    | '/$orgPid/dashboard'
    | '/$orgPid/dynamic-pricing'
    | '/$orgPid/integrations'
    | '/$orgPid/market-explorer'
    | '/$orgPid/members'
    | '/$orgPid/messaging'
    | '/$orgPid/owners'
    | '/$orgPid/price-alerts'
    | '/$orgPid/pricing-calendar'
    | '/$orgPid/revenue'
    | '/$orgPid/roles'
    | '/$orgPid/subscriptions'
    | '/admin/charters'
    | '/admin/companies'
    | '/admin/dashboard'
    | '/admin/jobs'
    | '/admin/users'
    | '/owner-status/$token'
    | '/admin'
    | '/$orgPid/analytics/competitors'
    | '/$orgPid/analytics/goals'
    | '/$orgPid/analytics/income'
    | '/$orgPid/analytics/occupancy'
    | '/$orgPid/analytics/revenue'
    | '/$orgPid/competitor-sets/$pid'
    | '/$orgPid/analytics'
    | '/$orgPid/competitor-sets'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/$orgPid'
    | '/admin'
    | '/forgot-password'
    | '/get-started'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/$orgPid/activity'
    | '/$orgPid/analytics'
    | '/$orgPid/dashboard'
    | '/$orgPid/dynamic-pricing'
    | '/$orgPid/integrations'
    | '/$orgPid/market-explorer'
    | '/$orgPid/members'
    | '/$orgPid/messaging'
    | '/$orgPid/owners'
    | '/$orgPid/price-alerts'
    | '/$orgPid/pricing-calendar'
    | '/$orgPid/revenue'
    | '/$orgPid/roles'
    | '/$orgPid/subscriptions'
    | '/admin/charters'
    | '/admin/companies'
    | '/admin/dashboard'
    | '/admin/jobs'
    | '/admin/users'
    | '/owner-status/$token'
    | '/admin/'
    | '/$orgPid/analytics/competitors'
    | '/$orgPid/analytics/goals'
    | '/$orgPid/analytics/income'
    | '/$orgPid/analytics/occupancy'
    | '/$orgPid/analytics/revenue'
    | '/$orgPid/competitor-sets/$pid'
    | '/$orgPid/analytics/'
    | '/$orgPid/competitor-sets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  OrgPidRoute: typeof OrgPidRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GetStartedRoute: typeof GetStartedRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TermsRoute: typeof TermsRoute
  OwnerStatusTokenRoute: typeof OwnerStatusTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgPid': {
      id: '/$orgPid'
      path: '/$orgPid'
      fullPath: '/$orgPid'
      preLoaderRoute: typeof OrgPidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/owner-status/$token': {
      id: '/owner-status/$token'
      path: '/owner-status/$token'
      fullPath: '/owner-status/$token'
      preLoaderRoute: typeof OwnerStatusTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs': {
      id: '/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AdminJobsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies': {
      id: '/admin/companies'
      path: '/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/charters': {
      id: '/admin/charters'
      path: '/charters'
      fullPath: '/admin/charters'
      preLoaderRoute: typeof AdminChartersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/$orgPid/subscriptions': {
      id: '/$orgPid/subscriptions'
      path: '/subscriptions'
      fullPath: '/$orgPid/subscriptions'
      preLoaderRoute: typeof OrgPidSubscriptionsRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/roles': {
      id: '/$orgPid/roles'
      path: '/roles'
      fullPath: '/$orgPid/roles'
      preLoaderRoute: typeof OrgPidRolesRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/revenue': {
      id: '/$orgPid/revenue'
      path: '/revenue'
      fullPath: '/$orgPid/revenue'
      preLoaderRoute: typeof OrgPidRevenueRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/pricing-calendar': {
      id: '/$orgPid/pricing-calendar'
      path: '/pricing-calendar'
      fullPath: '/$orgPid/pricing-calendar'
      preLoaderRoute: typeof OrgPidPricingCalendarRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/price-alerts': {
      id: '/$orgPid/price-alerts'
      path: '/price-alerts'
      fullPath: '/$orgPid/price-alerts'
      preLoaderRoute: typeof OrgPidPriceAlertsRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/owners': {
      id: '/$orgPid/owners'
      path: '/owners'
      fullPath: '/$orgPid/owners'
      preLoaderRoute: typeof OrgPidOwnersRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/messaging': {
      id: '/$orgPid/messaging'
      path: '/messaging'
      fullPath: '/$orgPid/messaging'
      preLoaderRoute: typeof OrgPidMessagingRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/members': {
      id: '/$orgPid/members'
      path: '/members'
      fullPath: '/$orgPid/members'
      preLoaderRoute: typeof OrgPidMembersRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/market-explorer': {
      id: '/$orgPid/market-explorer'
      path: '/market-explorer'
      fullPath: '/$orgPid/market-explorer'
      preLoaderRoute: typeof OrgPidMarketExplorerRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/integrations': {
      id: '/$orgPid/integrations'
      path: '/integrations'
      fullPath: '/$orgPid/integrations'
      preLoaderRoute: typeof OrgPidIntegrationsRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/dynamic-pricing': {
      id: '/$orgPid/dynamic-pricing'
      path: '/dynamic-pricing'
      fullPath: '/$orgPid/dynamic-pricing'
      preLoaderRoute: typeof OrgPidDynamicPricingRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/dashboard': {
      id: '/$orgPid/dashboard'
      path: '/dashboard'
      fullPath: '/$orgPid/dashboard'
      preLoaderRoute: typeof OrgPidDashboardRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/analytics': {
      id: '/$orgPid/analytics'
      path: '/analytics'
      fullPath: '/$orgPid/analytics'
      preLoaderRoute: typeof OrgPidAnalyticsRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/activity': {
      id: '/$orgPid/activity'
      path: '/activity'
      fullPath: '/$orgPid/activity'
      preLoaderRoute: typeof OrgPidActivityRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/competitor-sets/': {
      id: '/$orgPid/competitor-sets/'
      path: '/competitor-sets'
      fullPath: '/$orgPid/competitor-sets/'
      preLoaderRoute: typeof OrgPidCompetitorSetsIndexRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/analytics/': {
      id: '/$orgPid/analytics/'
      path: '/'
      fullPath: '/$orgPid/analytics/'
      preLoaderRoute: typeof OrgPidAnalyticsIndexRouteImport
      parentRoute: typeof OrgPidAnalyticsRoute
    }
    '/$orgPid/competitor-sets/$pid': {
      id: '/$orgPid/competitor-sets/$pid'
      path: '/competitor-sets/$pid'
      fullPath: '/$orgPid/competitor-sets/$pid'
      preLoaderRoute: typeof OrgPidCompetitorSetsPidRouteImport
      parentRoute: typeof OrgPidRoute
    }
    '/$orgPid/analytics/revenue': {
      id: '/$orgPid/analytics/revenue'
      path: '/revenue'
      fullPath: '/$orgPid/analytics/revenue'
      preLoaderRoute: typeof OrgPidAnalyticsRevenueRouteImport
      parentRoute: typeof OrgPidAnalyticsRoute
    }
    '/$orgPid/analytics/occupancy': {
      id: '/$orgPid/analytics/occupancy'
      path: '/occupancy'
      fullPath: '/$orgPid/analytics/occupancy'
      preLoaderRoute: typeof OrgPidAnalyticsOccupancyRouteImport
      parentRoute: typeof OrgPidAnalyticsRoute
    }
    '/$orgPid/analytics/income': {
      id: '/$orgPid/analytics/income'
      path: '/income'
      fullPath: '/$orgPid/analytics/income'
      preLoaderRoute: typeof OrgPidAnalyticsIncomeRouteImport
      parentRoute: typeof OrgPidAnalyticsRoute
    }
    '/$orgPid/analytics/goals': {
      id: '/$orgPid/analytics/goals'
      path: '/goals'
      fullPath: '/$orgPid/analytics/goals'
      preLoaderRoute: typeof OrgPidAnalyticsGoalsRouteImport
      parentRoute: typeof OrgPidAnalyticsRoute
    }
    '/$orgPid/analytics/competitors': {
      id: '/$orgPid/analytics/competitors'
      path: '/competitors'
      fullPath: '/$orgPid/analytics/competitors'
      preLoaderRoute: typeof OrgPidAnalyticsCompetitorsRouteImport
      parentRoute: typeof OrgPidAnalyticsRoute
    }
  }
}

interface OrgPidAnalyticsRouteChildren {
  OrgPidAnalyticsCompetitorsRoute: typeof OrgPidAnalyticsCompetitorsRoute
  OrgPidAnalyticsGoalsRoute: typeof OrgPidAnalyticsGoalsRoute
  OrgPidAnalyticsIncomeRoute: typeof OrgPidAnalyticsIncomeRoute
  OrgPidAnalyticsOccupancyRoute: typeof OrgPidAnalyticsOccupancyRoute
  OrgPidAnalyticsRevenueRoute: typeof OrgPidAnalyticsRevenueRoute
  OrgPidAnalyticsIndexRoute: typeof OrgPidAnalyticsIndexRoute
}

const OrgPidAnalyticsRouteChildren: OrgPidAnalyticsRouteChildren = {
  OrgPidAnalyticsCompetitorsRoute: OrgPidAnalyticsCompetitorsRoute,
  OrgPidAnalyticsGoalsRoute: OrgPidAnalyticsGoalsRoute,
  OrgPidAnalyticsIncomeRoute: OrgPidAnalyticsIncomeRoute,
  OrgPidAnalyticsOccupancyRoute: OrgPidAnalyticsOccupancyRoute,
  OrgPidAnalyticsRevenueRoute: OrgPidAnalyticsRevenueRoute,
  OrgPidAnalyticsIndexRoute: OrgPidAnalyticsIndexRoute,
}

const OrgPidAnalyticsRouteWithChildren = OrgPidAnalyticsRoute._addFileChildren(
  OrgPidAnalyticsRouteChildren,
)

interface OrgPidRouteChildren {
  OrgPidActivityRoute: typeof OrgPidActivityRoute
  OrgPidAnalyticsRoute: typeof OrgPidAnalyticsRouteWithChildren
  OrgPidDashboardRoute: typeof OrgPidDashboardRoute
  OrgPidDynamicPricingRoute: typeof OrgPidDynamicPricingRoute
  OrgPidIntegrationsRoute: typeof OrgPidIntegrationsRoute
  OrgPidMarketExplorerRoute: typeof OrgPidMarketExplorerRoute
  OrgPidMembersRoute: typeof OrgPidMembersRoute
  OrgPidMessagingRoute: typeof OrgPidMessagingRoute
  OrgPidOwnersRoute: typeof OrgPidOwnersRoute
  OrgPidPriceAlertsRoute: typeof OrgPidPriceAlertsRoute
  OrgPidPricingCalendarRoute: typeof OrgPidPricingCalendarRoute
  OrgPidRevenueRoute: typeof OrgPidRevenueRoute
  OrgPidRolesRoute: typeof OrgPidRolesRoute
  OrgPidSubscriptionsRoute: typeof OrgPidSubscriptionsRoute
  OrgPidCompetitorSetsPidRoute: typeof OrgPidCompetitorSetsPidRoute
  OrgPidCompetitorSetsIndexRoute: typeof OrgPidCompetitorSetsIndexRoute
}

const OrgPidRouteChildren: OrgPidRouteChildren = {
  OrgPidActivityRoute: OrgPidActivityRoute,
  OrgPidAnalyticsRoute: OrgPidAnalyticsRouteWithChildren,
  OrgPidDashboardRoute: OrgPidDashboardRoute,
  OrgPidDynamicPricingRoute: OrgPidDynamicPricingRoute,
  OrgPidIntegrationsRoute: OrgPidIntegrationsRoute,
  OrgPidMarketExplorerRoute: OrgPidMarketExplorerRoute,
  OrgPidMembersRoute: OrgPidMembersRoute,
  OrgPidMessagingRoute: OrgPidMessagingRoute,
  OrgPidOwnersRoute: OrgPidOwnersRoute,
  OrgPidPriceAlertsRoute: OrgPidPriceAlertsRoute,
  OrgPidPricingCalendarRoute: OrgPidPricingCalendarRoute,
  OrgPidRevenueRoute: OrgPidRevenueRoute,
  OrgPidRolesRoute: OrgPidRolesRoute,
  OrgPidSubscriptionsRoute: OrgPidSubscriptionsRoute,
  OrgPidCompetitorSetsPidRoute: OrgPidCompetitorSetsPidRoute,
  OrgPidCompetitorSetsIndexRoute: OrgPidCompetitorSetsIndexRoute,
}

const OrgPidRouteWithChildren =
  OrgPidRoute._addFileChildren(OrgPidRouteChildren)

interface AdminRouteChildren {
  AdminChartersRoute: typeof AdminChartersRoute
  AdminCompaniesRoute: typeof AdminCompaniesRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminJobsRoute: typeof AdminJobsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminChartersRoute: AdminChartersRoute,
  AdminCompaniesRoute: AdminCompaniesRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminJobsRoute: AdminJobsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  OrgPidRoute: OrgPidRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GetStartedRoute: GetStartedRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TermsRoute: TermsRoute,
  OwnerStatusTokenRoute: OwnerStatusTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
